import { CollectionAction } from '../collection-action.interface';
import { CollectionAsset } from '../collection-asset';
import { CollectionState } from '../collection-state.interface';

const onAddAssetRequest = (
  state: CollectionState,
  action: CollectionAction,
): CollectionState => ({
  ...state,
  listOfCollections: state.listOfCollections.map((collection) => {
    if (collection.collectionId === action.collectionId) {
      const newAssets = [
        ...collection.assets,
        ...(action.assets as CollectionAsset[]),
      ];

      return {
        ...collection,
        assets: newAssets,
        count: newAssets.length,
      };
    }

    return collection;
  }),
});

export default onAddAssetRequest;
